import I18n from 'I18n';
import { AVG, COUNT, DISTINCT_APPROX, MAX, MIN, PERCENTILES, SUM } from 'reporting-data/constants/metricTypes';
const translationKeys = {
  SUM: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.SUM',
  AVG: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.AVG',
  MIN: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.MIN',
  MAX: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.MAX',
  COUNT: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.COUNT',
  PERCENTILES: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.PERCENTILES',
  DISTINCT_APPROX: 'report-customization-components.customization-components.metrics-editor-dropdown.config.aggregations.options.DISTINCT_APPROX'
};
export const getAggregationOption = aggregationOption => {
  if (translationKeys[aggregationOption]) {
    return {
      text: I18n.text(translationKeys[aggregationOption]),
      value: aggregationOption
    };
  }
  return {
    text: aggregationOption,
    value: aggregationOption
  };
};
const getShouldOnlyShowSumMetric = (propertyName, aggregationValue, propertyMetadata) => {
  const isCount = propertyName === 'count';
  const isHubSpotMetricsProperty = propertyMetadata && propertyMetadata.get && propertyMetadata.get('groupName') === 'hubspotmetrics';
  return isCount || [COUNT].includes(aggregationValue) || (propertyName === null || propertyName === void 0 ? void 0 : propertyName.startsWith('raas_')) || isHubSpotMetricsProperty;
};
export const getAggregationOptionsForDropdown = (propertyName, aggregationValue, propertyMetadata) => {
  if (getShouldOnlyShowSumMetric(propertyName, aggregationValue, propertyMetadata)) {
    return [getAggregationOption(SUM)];
  } else if (aggregationValue === DISTINCT_APPROX) {
    return [getAggregationOption(DISTINCT_APPROX)];
  }
  return [AVG, MAX, PERCENTILES, MIN, SUM].map(aggregation => {
    return getAggregationOption(aggregation);
  });
};